import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { Cap1CfarPostBookingOfferMerchandising as Cap1CfarPostBookingOfferMerchandisingComponent } from "./component";
import { cfarPostBookingOfferSelector } from "../../reducer/selectors/postBooking";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  cfarOffer: cfarPostBookingOfferSelector(state),
  selectedAccountReferenceId:
    getSelectedAccountReferenceIdIfRedemptionEnabled(state),
});

const connector = connect(mapStateToProps);

export type Cap1CfarPostBookingOfferMerchandisingConnectorProps =
  ConnectedProps<typeof connector>;

export const Cap1CfarPostBookingOfferMerchandising = connector(
  Cap1CfarPostBookingOfferMerchandisingComponent,
);
